import React from "react";
import PropTypes from "prop-types";
import { TableCell, TableRow, Checkbox } from "@mui/material";
import { TextField, IconButton, Autocomplete } from "@totalsoft/rocket-ui";
import CancelIcon from "@mui/icons-material/Cancel";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import { isValid, getErrors } from "@totalsoft/pure-validations-react";
import { withParams } from "providers/ParamsConsumer";
import PhoneNumberField from "components/common/PhoneNumberTextField";

export const ContactModeRowComponent = ({
  idx,
  contactMode,
  contactModes,
  deleteContactMode,
  onPropertyChange,
  validation,
  hasWritePermission,
  params
}) => (
  <TableRow>
    <TableCell colSpan={4} style={{ paddingRight: "70px" }}>
      <Autocomplete
        id={"contactMode_contactMode_" + idx}
        fullWidth
        value={contactModes.length > 0 ? contactMode.contactModeId || "" : ""}
        labelKey="contactModeName"
        valueKey="contactModeId"
        simpleValue={true}
        error={!isValid(validation.contactModeId)}
        helperText={getErrors(validation.contactModeId)}
        onChange={onPropertyChange("contactModeId")}
        disabled={!hasWritePermission}
        options={contactModes}
      />
    </TableCell>

    <TableCell colSpan={4} style={{ paddingRight: "0px" }}>
      {contactMode.contactModeId === params.contactModeEmail && (
        <TextField
          id={"contactMode_contactInfo_" + idx}
          name={"contactInfo"}
          fullWidth
          value={contactMode.contactInfo || ""}
          error={!isValid(validation.contactInfo)}
          helperText={getErrors(validation.contactInfo)}
          onChange={onPropertyChange("contactInfo")}
          disabled={!hasWritePermission}
        />
      )}
      {(contactMode.contactModeId === params.contactModeMobilePhone ||
        contactMode.contactModeId === params.contactModePhone) && (
        <PhoneNumberField
          id={"contactMode_contactInfo_" + idx}
          defaultCountry={params.defaultCountryCode}
          country={contactMode.phoneCountryCode}
          name={"contactInfo"}
          fullWidth
          variant="standard"
          value={contactMode.contactInfo || ""}
          error={!isValid(validation.contactInfo)}
          helperText={getErrors(validation.contactInfo)}
          onChange={onPropertyChange("contactInfo")}
          disabled={!hasWritePermission}
        />
      )}
    </TableCell>
    <TableCell colSpan={2} style={{ paddingRight: "0px", textAlign: "center" }}>
      <Checkbox
        id={"contactMode_smsNotification_" + idx}
        checked={Boolean(contactMode.smsNotification)}
        onChange={onCheckBoxChange(onPropertyChange("smsNotification"))}
        disabled={!hasWritePermission}
        color="primary"
        name="external"
      />
    </TableCell>
    <TableCell colSpan={2} style={{ paddingRight: "0px", textAlign: "center" }}>
      <Checkbox
        id={"contactMode_isDefault_" + idx}
        checked={Boolean(contactMode.isDefault)}
        onChange={onCheckBoxChange(onPropertyChange("isDefault"))}
        disabled={!hasWritePermission}
        color="primary"
        name="isDefault"
      />
    </TableCell>
    <TableCell sx={{ textAlign: "right" }}>
      <IconButton
        id="contactMode_deleteBtn"
        color="primary"
        variant="text"
        onClick={() => deleteContactMode()}
        disabled={!hasWritePermission}
      >
        <CancelIcon />
      </IconButton>
    </TableCell>
  </TableRow>
);

ContactModeRowComponent.propTypes = {
  idx: PropTypes.number,
  params: PropTypes.object,
  deleteContactMode: PropTypes.func,
  onPropertyChange: PropTypes.func.isRequired,
  contactMode: PropTypes.object.isRequired,
  contactModes: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
  hasWritePermission: PropTypes.bool.isRequired
};
export default withParams(ContactModeRowComponent);
